import type {DiffAnchor} from '@github-ui/diffs/types'

const DIFF_ANCHOR_PREFIX = 'diff-'

export function isDiffAnchor(value: unknown): value is DiffAnchor {
  return typeof value === 'string' && value.startsWith(DIFF_ANCHOR_PREFIX)
}

/**
 * Returns the portion of a diff anchor string after the {@link DIFF_ANCHOR_PREFIX} (`"diff-"`).
 *
 * This function does not attempt to parse or strip any line numbers or ranges that may be
 * appended to the digest; it simply removes the `"diff-"` prefix and returns the remainder.
 *
 * Examples:
 * - `"diff-abc123"`        → `"abc123"`
 * - `"diff-abc123L1"`      → `"abc123L1"`
 * - `"diff-abc123L1-L2"`   → `"abc123L1-L2"`
 * - `"abc123"`             → `""` (not a valid diff anchor)
 *
 * @param diffAnchor - A diff anchor string, expected to start with `"diff-"`.
 * @returns The substring after `"diff-"`, or an empty string if {@link isDiffAnchor} returns false.
 */
export function pathDigestFromDiffAnchor(diffAnchor: DiffAnchor | string): string {
  if (!isDiffAnchor(diffAnchor)) {
    return ''
  }
  // DiffAnchor is `diff-${string}` → strip the prefix to get the digest (which may include line info)
  return diffAnchor.slice(DIFF_ANCHOR_PREFIX.length)
}
